import {
     trigger,
     state,
     style,
     transition,
     animate,
   } from "@angular/animations";
   
   export const slideToggle = trigger("slideToggle", [
     state(
       "closed",
       style({
         height: "0",
         overflow: "hidden",
       })
     ),
     state(
       "open",
       style({
         height: "*",
         overflow: "hidden",
       })
     ),
     transition("closed <=> open", animate("300ms ease-in-out")),
   ]);